import { ICfop } from "../interfaces/ICfop";
import { IImpostoProduto } from "../interfaces/IImpostoProduto";
import { INcm } from "../interfaces/INcm";

/**
 * NCM base sugerido para produção própria (almoços, jantares, refeições e pizzas):
 * "Preparações alimentícias diversas". É o mesmo default aplicado no backend (ms-produtos).
 */
export const NCM_PADRAO_PRODUCAO_PROPRIA = "21069090";

/**
 * Imposto base sugerido para produtos de produção própria (pizza, preparado, combo, peso).
 * Espelha o default do ProdutoFactory no ms-produtos — o usuário pode customizar no formulário.
 */
export const IMPOSTO_PADRAO_PRODUCAO_PROPRIA: IImpostoProduto = {
    ncm: NCM_PADRAO_PRODUCAO_PROPRIA,
    // 5101 = venda de produção do estabelecimento (padrão SEFAZ/Focus).
    cfop: "5101",
    icmsOrigem: "0",
    icmsModalidadeBaseCalculo: "3",
    // Simples Nacional (CSOSN 102): sem ICMS destacado → alíquota e base 0.
    // É o mesmo valor que o ms-pedidos assume quando o campo não vem preenchido.
    icmsAliquota: 0,
    icmsBaseCalculo: 0,
};

/**
 * NCMs sugeridos para produção própria — usados como opções iniciais no autocomplete,
 * antes de qualquer busca na Focus NFe.
 */
export const NCMS_SUGERIDOS: INcm[] = [
    { codigo: "21069090", descricao: "Preparações alimentícias diversas (almoços, refeições, pizzas)" },
    { codigo: "16042090", descricao: "Preparações de carne, peixe ou crustáceos (sushi, sashimi e similares)" },
];

/**
 * CFOPs de saída mais comuns (padrão SEFAZ/Focus) — opções iniciais do autocomplete,
 * antes de qualquer busca na Focus NFe.
 */
export const CFOPS_SUGERIDOS: ICfop[] = [
    { codigo: "5101", descricao: "Venda de produção do estabelecimento" },
    { codigo: "5102", descricao: "Venda de mercadoria adquirida ou recebida de terceiros" },
];

// Tabela A da SEFAZ (campo icms_origem/orig da Focus NFe).
export const OPCOES_ICMS_ORIGEM: { valor: string; descricao: string }[] = [
    { valor: "0", descricao: "0 - Nacional" },
    { valor: "1", descricao: "1 - Estrangeira - importação direta" },
    { valor: "2", descricao: "2 - Estrangeira - adquirida no mercado interno" },
    { valor: "3", descricao: "3 - Nacional, conteúdo de importação entre 40% e 70%" },
    { valor: "4", descricao: "4 - Nacional, produção conforme processos produtivos básicos" },
    { valor: "5", descricao: "5 - Nacional, conteúdo de importação até 40%" },
    { valor: "6", descricao: "6 - Estrangeira - importação direta, sem similar nacional" },
    { valor: "7", descricao: "7 - Estrangeira - mercado interno, sem similar nacional" },
    { valor: "8", descricao: "8 - Nacional, conteúdo de importação superior a 70%" },
];

export const OPCOES_ICMS_MODALIDADE_BASE_CALCULO: { valor: string; descricao: string }[] = [
    { valor: "0", descricao: "0 - Margem Valor Agregado (%)" },
    { valor: "1", descricao: "1 - Pauta (valor)" },
    { valor: "2", descricao: "2 - Preço tabelado máx. (valor)" },
    { valor: "3", descricao: "3 - Valor da operação" },
];
